import { useCallback, useEffect, useRef } from 'react';

export const useBatchedChunks = (callback, delay = 100) => {
  // Use useRef to store the batch of events.
  // We use useRef instead of useState because we don't want to trigger a re-render
  // every time a new event is added to the buffer. We only want to re-render
  // when the final batch is processed.
  const chunkBuffer = useRef([]);
  const timerRef = useRef(null);

  const flushChunks = useCallback(() => {
    callback(chunkBuffer.current);
    chunkBuffer.current = [];
  }, [callback]);

  const pushChunk = useCallback(
    event => {
      chunkBuffer.current.push(event);

      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }

      timerRef.current = setTimeout(flushChunks, delay);
    },
    [delay, flushChunks]
  );

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return pushChunk;
};
